import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Link, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    width: '100%',
    backgroundColor: '#f5f5f5',
    padding: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(6),
    fontWeight: 'bold',
    color: '#333',
  },
  programContainer: {
    maxWidth: 800,
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'inherit',
    transition: 'transform 0.2s',
    '&:hover': {
      transform: 'scale(1.05)',
      textDecoration: 'none',
    },
  },
  logo: {
    //maxWidth: 350,
    maxHeight: 100,
    height: 'auto',
    marginBottom: theme.spacing(2),
  },
  caption: {
    fontWeight: 'medium',
    textAlign: 'center',
  },
}));

const ProgramSelector = () => {
  const classes = useStyles();

  const programs = [
    {
      logo: 'https://storage.googleapis.com/ps-client-acd-apse2-prod-assets/theme/logo/ACD%20Rewards%20-%20Default%20Logo%20copy.png',
      caption: 'ACD Trade Rewards',
      link: 'https://www.acdtraderewards.com.au/',
    },
    {
      logo: 'https://storage.googleapis.com/ps-client-cas-apse2-prod-assets/theme/email_templates/logo.png',
      caption: 'Complete Air Supply Rewards',
      link: 'https://www.completeairsupplyrewards.com.au',
    },
  ];

  return (
    <Box className={classes.root}>
      <Typography variant="h4" className={classes.title}>
        Please select your Rewards Program:
      </Typography>
      <Grid container spacing={8} justifyContent="center" className={classes.programContainer}>
        {programs.map((program, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Link href={program.link} className={classes.logoContainer}>
              <img src={program.logo} alt={program.caption} className={classes.logo} />
              <Typography variant="h6" className={classes.caption}>
                {program.caption}
              </Typography>
            </Link>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProgramSelector;
